import CityPageTemplate from "../city-template/CityPageTemplate";
import { evanstonWyConfig } from "./data";

export default function EvanstonWyPage() {
  return <CityPageTemplate config={evanstonWyConfig} />;
}